import * as DatabasePaths from 'stores/DatabasePaths';

export function computeCreativeStorageScope(creativeDatabasePath: string) {
    // I don't have a great place to put this at the moment!
    const { creativeID, clientID, projectID } =
        DatabasePaths.creative.requireMatch(creativeDatabasePath);
    return `${clientID}/${projectID}/${creativeID}`;
}
